
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Tab1575313560",
      {"classes":{"root":"Tab1575313560__root","insetFocusRing":"palette2961688738__insetFocusRing","tabContentWrapper":"Tab1575313560__tabContentWrapper","prefix":"Tab1575313560__prefix"},"vars":{"wix-color-8":"--wix-color-8","wix-ui-tpa-tab-selected-indicator-color":"--wix-ui-tpa-tab-selected-indicator-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  